<template>
  <div class="d-flex" id="page-dashboard">
    <b-container fluid>
      <b-row>
        <b-col
          cols="12"
          class="cont-title d-flex align-items-center mb-5 break-padding"
        >
          <span class="icon icon-wait-clock mr-3"></span>
          <h3 class="mb-0">Uso de permisos y tiquetes en el tiempo</h3>
        </b-col>
        <b-col class="mb-4">
          <Filters
            :errors="errorOfFilters"
            @change:sindicate-id="changeSyndicate"
            @change:user-selected="changeSelectUser"
            @change:range-dates="changeRangeDates"
            @click:clear-filter="clearFilter"
          />
          <div class="d-none">
            <div class="w-100 d-flex justify-content-end">
              <select
                v-model="yearSel"
                class="chart-select"
                @change="findDashboard"
              >
                <option :value="this.year">Año {{ this.year }}</option>
                <option :value="this.year - 1">Año {{ this.year - 1 }}</option>
                <option :value="this.year - 2">Año {{ this.year - 2 }}</option>
              </select>
            </div>
            <div
              v-if="user.core_role_id != '1' && user.core_role_id != '6'"
              class="w-100 d-flex justify-content-end"
            >
              <select
                v-model="laborUnion"
                class="chart-select"
                @change="findDashboard"
              >
                <option value="">--Filtrar Sindicato--</option>
                <option
                  v-for="laborUnion in laborUnions.data"
                  v-bind:key="laborUnion.id"
                  v-bind:value="laborUnion.id"
                >
                  {{ laborUnion.name }}
                </option>
              </select>
            </div>
          </div>
        </b-col>
      </b-row>

      <!-- tarjeta del usuario -->
      <template v-if="userSelected.is_show">
        <b-row>
          <b-col
            class="shadow-1 py-1 py-md-4 px-2 px-md-5 position-relative info-user mb-4"
          >
            <div class="">
              <img
                class="logo-user"
                src="../../assets/images/icons/icon-user.svg"
                style="margin: auto"
                alt="logo"
              />
            </div>
            <div class="text-left">
              <p>{{ userSelected.name }}</p>
              <p>Cc. {{ userSelected.identification_number }}</p>
              <p>SharpID {{ userSelected.sharp_id }}</p>
            </div>
          </b-col>
        </b-row>
      </template>
      <!--end -->

      <!-- graficas  dateRanges.is_show"-->
      <template>
        <b-row>
          <b-col
            class="mb-4 break-padding shadow-1 py-1 px-2 position-relative"
          >
            <b-overlay
              :show="processingGraphic"
              spinner-variant="primary"
              spinner-type="grow"
              spinner-small
              rounded="sm"
            >
              <b-row class="align-items-end no-padding">
                <button
                  class="button-descargar"
                  @click.prevent="downloadReportOfLaborUnion"
                  :disabled="isProcessingDownloadlaborunion"
                  v-if="dateRanges.is_show"
                >
                  Descargar informe
                </button>
                <template v-if="userSelected.is_show">
                  <h3>
                    {{ userSelected.name }} pertenece a
                    {{ userSelected.count_of_unions }} sindicatos
                  </h3>
                  <button
                    class="button-descargar"
                    @click.prevent="downloadReportOfEmployee"
                    :disabled="isProcessingDownload"
                  >
                    Descargar informe
                  </button>
                  <ul
                    class="box-tabs col-12 mt-5 mb-5 shadow-none position-relative"
                  >
                    <li
                      v-for="(union, indexUnion) in userSelected.list_of_unions"
                      :key="indexUnion"
                      class="nav-item"
                      @click="currentTab = indexUnion"
                      :class="{ active: currentTab === indexUnion }"
                    >
                      <a
                        href="#"
                        data-toggle="tab"
                        @click="onTabChanged(union.id, userSelected.sharp_id)"
                      >
                        {{ union.name }}
                      </a>
                    </li>
                  </ul>
                </template>
                <b-col cols="12" sm="6" class="border-column">
                  <div class="title-chart-multi mt-4 mb-4">
                    Días de Permisos aprobados
                  </div>
                  <bar-chart
                    :chart-data="permissionsDataCollection"
                    :options="permissionsChartOptions"
                  />
                </b-col>
                <b-col cols="12" sm="6">
                  <div class="title-chart-multi mt-4 mb-4">Tiquetes</div>
                  <bar-chart
                    :chart-data="ticketsLineChartdatacollection"
                    :options="ticketLineChartOptions"
                  />
                </b-col>
              </b-row>
            </b-overlay>
          </b-col>
        </b-row>
      </template>
      <!--end -->

      <!-- informacion del trabajador -->
      <template v-if="userSelected.is_show">
        <b-row>
          <b-col cols="12" class="mb-3 break-padding">
            <h3 class="text-left">Información general del trabajador</h3>
          </b-col>

          <b-col class="d-flex box-medium mb-4">
            <b-col class="shadow-1 p-4 px-5">
              <p>Permisos aprobados sin tiquetes</p>
              <p>{{ this.workInformation.approved_without_tickets }}</p>
            </b-col>
            <b-col class="shadow-1 p-4 px-5">
              <p>Permisos aprobados con tiquetes</p>
              <p>{{ this.workInformation.approved_with_tickets }}</p>
            </b-col>
            <b-col class="shadow-1 p-4 px-5">
              <p>Permisos no aprobados</p>
              <p>{{ this.workInformation.not_approved }}</p>
            </b-col>
          </b-col>
        </b-row>
      </template>

      <!-- end -->

      <!-- informacion del sindicato -->
      <b-row>
        <b-col cols="12" class="break-padding">
          <h3 class="text-left pb-3">Información del Sindicato</h3>
        </b-col>
        <b-col class="break-padding">
          <div class="shadow-1 py-1 mt-1 mb-5 text-left p-4">
            <p>Acuerdo convencional</p>
            <div class="d-flex box-info-sindicato">
              <p>
                Desde
                <span
                  >{{
                    getLaborUnionSocietyConventionalPeriod.conventional_agreement
                  }}
                </span>
              </p>
              <p>
                Total días de permisos
                <strong>{{
                  getLaborUnionSocietyConventionalPeriod.days.total
                }}</strong>
              </p>
              <p>
                Total de tiquetes nacionales
                <strong>{{
                  getLaborUnionSocietyConventionalPeriod.ticket_nationals.total
                }}</strong>
              </p>
              <p>
                Total de tiquetes internacionales
                <strong>{{
                  getLaborUnionSocietyConventionalPeriod.ticket_internationals
                    .total
                }}</strong>
              </p>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row align-h="between" class="box-content-main-graph">
        <b-col class="pb-3 item-graph_one">
          <b-row class="shadow-1 position-relative cont-doughnut-chart">
            <b-col
              cols="12"
              class="cont-title d-flex align-items-center mb-4 pt-3"
            >
              <span class="icon icon-check-calendar mr-3"></span>
              <h3 class="mb-0">Seguimiento de días de permisos</h3>
            </b-col>
            <b-col cols="12">
              <div
                class="py-1 py-md-3 px-2 px-md-5 position-relative cont-doughnut-chart col"
              >
                <p class="m-0 col-12 mb-4 title-top">
                  Total días permitidos
                  <span>
                    {{ getLaborUnionSocietyConventionalPeriod.days.total }}
                  </span>
                </p>
                <div class="dashboard-permissions">
                  <availability-permissions-chart
                    :chart-data="availabilityPermisionsChartdatacollection"
                    :options="availabilityPermisionChartOptions"
                  />
                </div>
                <div class="cont-txt position-absolute text-center">
                  <p class="title">Días utilizados</p>
                  <p class="number">
                    {{ getLaborUnionSocietyConventionalPeriod.days.used }}
                  </p>
                  <div class="cont-desc">
                    <p class="title">Días adicionales utilizados</p>
                    <p class="number">
                      {{
                        getLaborUnionSocietyConventionalPeriod.days.additional
                      }}
                    </p>
                  </div>
                  <!-- .cont-desc -->
                </div>
              </div>
              <div class="box-info-total p-5">
                <p class="text-card-grafic">
                  Total de días de permisos utilizados:
                </p>
                <span class="text-card-grafic-number">
                  {{ getLaborUnionSocietyConventionalPeriod.days.used }}
                </span>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="mb-4 item-graph_two">
          <b-row class="shadow-1 d-flex conten-grafic-ticket">
            <b-col
              cols="12"
              class="cont-title d-flex align-items-center mb-4 pt-3"
            >
              <span class="icon icon-airplane mr-3"></span>
              <h3 class="mb-0">Seguimiento de tiquetes</h3>
            </b-col>

            <b-col cols="12">
              <b-row class="col-12 box-content-ticket">
                <b-col
                  class="py-1 py-md-3 px-2 px-md-5 position-relative cont-doughnut-chart"
                >
                  <p class="m-0 col-12 mb-4 title-top">
                    Total de tiquetes nacionales
                    <span>
                      {{
                        getLaborUnionSocietyConventionalPeriod.ticket_nationals
                          .total
                      }}
                    </span>
                  </p>
                  <div class="dashboard-permissions">
                    <availability-permissions-chart
                      :chart-data="availabilityTicketsChartdatacollection"
                      :options="availabilityTicketsChartOptions"
                    />
                  </div>
                  <div class="cont-txt position-absolute text-center">
                    <p class="title">Tiquetes utilizados</p>
                    <p class="number">
                      {{
                        getLaborUnionSocietyConventionalPeriod.ticket_nationals
                          .used
                      }}
                    </p>
                    <div class="cont-desc">
                      <p class="title">Tiquetes adicionales utilizados</p>
                      <p class="number">
                        {{
                          getLaborUnionSocietyConventionalPeriod
                            .ticket_nationals.additional
                        }}
                      </p>
                    </div>
                    <!-- .cont-desc -->
                  </div>
                </b-col>
                <b-col
                  class="py-1 py-md-3 px-2 px-md-5 position-relative cont-doughnut-chart"
                >
                  <p class="m-0 col-12 mb-4 title-top">
                    Total de tiquetes internacionales
                    <span>{{
                      getLaborUnionSocietyConventionalPeriod
                        .ticket_internationals.total
                    }}</span>
                  </p>
                  <div class="dashboard-permissions">
                    <availability-permissions-chart
                      :chart-data="availabilityTicketsInterChartdatacollection"
                      :options="availabilityTicketsInterChartOptions"
                    />
                  </div>
                  <div class="cont-txt position-absolute text-center">
                    <p class="title">Tiquetes utilizados</p>
                    <p class="number">
                      {{
                        getLaborUnionSocietyConventionalPeriod
                          .ticket_internationals.used
                      }}
                    </p>
                    <div class="cont-desc">
                      <p class="title">Tiquetes adicionales utilizados</p>
                      <p class="number">
                        {{
                          getLaborUnionSocietyConventionalPeriod
                            .ticket_internationals.additional
                        }}
                      </p>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="box-info-total p-5">
                  <p class="text-card-grafic">
                    Total de tiquetes nacionales e internacionales utilizados:
                  </p>
                  <span class="text-card-grafic-number">
                    {{
                      getLaborUnionSocietyConventionalPeriod.total_ticket_national_international_used
                    }}
                  </span>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- end -->
      <b-row class="mt-4 mb-4">
        <b-col class="mb-4" cols="12">
          <b-row class="shadow-1 d-flex conten-grafic-ticket">
            <b-col
              cols="12"
              class="cont-title d-flex align-items-center mb-4 pt-3"
            >
              <span class="icon icon-airplane mr-3"></span>
              <h3 class="mb-0">Dinero gastado en tiquetes</h3>
            </b-col>

            <b-col cols="12">
              <div id="chart">
                <apexchart
                  :ref="refChart"
                  type="bar"
                  height="350"
                  :options="chartOptions"
                  :series="series"
                ></apexchart>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- graficas en tablas -->
      <b-row>
        <template v-if="canWithCode('solicitante-sindical')">
          <b-col
            cols="12"
            class="cont-title d-flex align-items-center break-padding mb-4"
          >
            <span class="icon icon-check-calendar mr-2"></span>
            <h3 class="mb-0">Población del Sindicado</h3>
          </b-col>
          <b-col class="shadow-1 cont-doughnut-chart">
            <b-row class="m-2">
              <b-col cols="2" sm="6" class="cont-permisions">
                <div class="text-center">
                  <p class="number">{{ this.population }}</p>
                  <p class="title">Personas</p>
                </div>
              </b-col>
              <b-col cols="2" sm="6" class="cont-permisions">
                <p class="number mr-3 mr-md-4 mb-0">{{ this.halfLicenses }}</p>
                <p class="txt mb-0">
                  Permisos solicitados con anticipación contabilizados como 1/2
                  permiso.
                </p>
              </b-col>
            </b-row>
          </b-col>
        </template>
        <template v-else>
          <b-col
            cols="12"
            class="cont-title d-flex align-items-center break-padding mb-4"
          >
            <h3 class="mb-0">
              Selecciona el item del que quieres ver estadísticas
            </h3>
          </b-col>
          <b-col
            class="shadow-1 py-1 px-2 position-relative cont-doughnut-chart"
          >
            <b-row>
              <b-col cols="12" sm="4">
                <b-card class="mt-3" header="Filtros" header-tag="header">
                  <p class="mt-3">Año:</p>
                  <b-form-select
                    v-model="yearSel2"
                    @change="findFilterBar($event)"
                  >
                    <option :value="this.year">{{ this.year }}</option>
                    <option :value="this.year - 1">{{ this.year - 1 }}</option>
                    <option :value="this.year - 2">{{ this.year - 2 }}</option>
                  </b-form-select>
                  <p class="mt-3">Item</p>
                  <b-form-select
                    v-model="item"
                    :options="opcionItem"
                    size="lg"
                    class="mt-0"
                    @change="findItemBar($event)"
                  >
                    <!--option value="">--Total--</option-->
                  </b-form-select>
                  <p class="mt-3">Sociedad</p>
                  <b-form-select
                    v-model="societySelect"
                    :options="opcionSocieties"
                    size="lg"
                    class="mt-0"
                    @change="findFilterBar($event)"
                  >
                  </b-form-select>
                  <p class="mt-3">Site</p>
                  <b-form-select
                    v-model="sitesSelect"
                    :options="opcionSites"
                    size="lg"
                    class="mt-0"
                    @change="findFilterBar($event)"
                  >
                  </b-form-select>
                </b-card>
              </b-col>
              <b-col cols="12" sm="8">
                <bar-chart
                  :chart-data="this.chartData"
                  :options="this.options"
                />
              </b-col>
            </b-row>
          </b-col>
        </template>
      </b-row>
      <!-- end -->
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import serverConfig from "./../../services/config";
import TimeTicketsChart from "@/components/charts/TimeTicketsChart.js";
import BarChart from "@/components/charts/BarChart.js";
import AvailabilityPermissionsChart from "@/components/charts/AvailabilityPermissionsChart.js";
import Filters from "@/components/Modules/PS/Dashboard/V2/Filters";
import { getStatisticsPayments } from "@/services/modules/permisos-sindicales/v2/statistics/service";
// import XLSX from "xlsx";

export default {
  name: "DashboardPermisos",
  components: {
    TimeTicketsChart,
    BarChart,
    AvailabilityPermissionsChart,
    Filters,
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      laborUnion: 1,
      year: new Date().getFullYear(),
      yearSel: "",
      yearSel2: "",
      halfLicenses: 0,
      permissionsDataCollection: {},
      ticketsLineChartdatacollection: {},
      ticketLineChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        type: "horizontalBar",
        legend: {
          align: "center",
          labels: {
            boxWidth: 15,
            fontSize: 15,
            padding: 10,
          },
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
      },
      permissionsChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        type: "horizontalBar",
        legend: {
          align: "center",
          labels: {
            boxWidth: 15,
            fontSize: 15,
            padding: 10,
          },
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
      },
      available_licenses: 0,
      available_tickets: 0,
      available_viatics: 0,
      population: 127,
      availabilityPermisionsChartdatacollection: {},
      availabilityTicketsChartdatacollection: {},
      availabilityTicketsInterChartdatacollection: {},
      availabilityViaticsChartdatacollection: {},
      availabilityPermisionChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        legend: {
          //   display: false,
          position: "bottom",
          labels: {
            usePointStyle: true,
            boxWidth: 12,
          },
        },
      },
      availabilityTicketsChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        legend: {
          //   display: false,
          position: "bottom",
          labels: {
            usePointStyle: true,
            boxWidth: 12,
          },
        },
      },
      availabilityTicketsInterChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        legend: {
          //   display: false,
          position: "bottom",
          labels: {
            usePointStyle: true,
            boxWidth: 12,
          },
        },
      },

      item: "Permisos",
      opcionItem: [
        { value: "Permisos", text: "Permisos" },
        { value: "TiquetesNacionales", text: "Tiquetes nacionales" },
        { value: "TiquetesInternacionales", text: "Tiquetes internacionales" },
        { value: "Viaticos", text: "Viáticos" },
      ],

      sitesSelect: "",
      opcionSites: [
        {
          value: "",
          text: "-- Todas --",
        },
      ],
      societySelect: "",
      opcionSocieties: [
        {
          value: "",
          text: "-- Todas --",
        },
      ],

      chartData: {},
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },

      titleOption: "Dashboard de Permisos Sindicales",
      syndicateId: null,
      userSelected: {
        is_show: false,
        sharp_id: null,
        name: null,
        list_of_unions: null,
        identification_number: null,
        count_of_unions: null,
      },
      dateRanges: {
        is_show: false,
        dateInit: "2020-01",
        dateEnd: "2022-12",
        totalYears: 3,
      },
      workInformation: {
        approved_with_tickets: 0,
        approved_without_tickets: 0,
        not_approved: 0,
      },
      isProcessingDownloadlaborunion: false,
      isProcessingDownload: false,
      errorOfFilters: {
        show: false,
        data: [],
      },
      tabTest: "",
      idOfSelectedSociety: null,
      conventionalAgreement: false,
      processingGraphic: false,
      series: [
        {
          name: "Nacionales",
          data: [],
        },
        {
          name: "Internacionales",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            borderRadius: 5,
            borderRadiusApplication: "end",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: "",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              const formatterPeso = new Intl.NumberFormat("es-CO", {
                style: "currency",
                currency: "COP",
                minimumFractionDigits: 0,
              });

              const price = val ? formatterPeso.format(Number(val)) : null;
              return price;
            },
          },
        },
      },
      refChart: "chart",
    };
  },
  beforeMount() {
    //Get data Labor WorkerInformation

    //End Get data Labor WorkerInformation
    let data = [];
    data[0] = this.year;
    data[1] = this.user.labor_union_admin_id
      ? this.user.labor_union_admin_id
      : 1; // Sindicado por defecto
    this.yearSel = this.year;
    this.yearSel2 = this.year;

    this.actGetDashboard(data)
      .then(() => {
        this.fillTicketsLineChartData(this.year);
        // this.fillAvailabilityPermisionsChart(this.year);
        // this.fillAvailabilityTicketsChart(this.year);
        this.halfLicenses = this.dashboard.data[this.year].half_day_licenses;
        //this.fillAvailabilityViaticsChart(this.year);
      })
      .catch((response) => {
        this.error.flag = true;
        this.error.class = "is-invalid";
        this.error.message = "No se pudo conectar al servicio: " + response;
      });

    let data2 = [];
    data2[0] = this.year;
    data2[1] = "";
    data2[2] = "";
    this.actGetDashboardBar(data2).then(() => {
      this.findItemBar(this.item);
    });

    this.actGetSites().then(() => {
      this.sites?.data?.forEach((site) => {
        this.opcionSites.push({
          value: site.id,
          text: site.name,
        });
      });
    });

    this.actGetSocieties().then(() => {
      this.societies?.data?.forEach((society) => {
        this.opcionSocieties.push({
          value: society.id,
          text: society.name,
        });
      });
    });

    this.actGetLaborUnions();
  },
  computed: {
    ...mapState("modCore", ["user"]),
    ...mapState("modRequest", [
      "dashboard",
      "laborUnions",
      "sites",
      "societies",
      "dashboardBar",
    ]),
    ...mapGetters("permisosSindicalesStatisticsLaborsUnions", [
      "getGraphicDataUnion",
      "getLaborWorkerInformation",
      "getLaborDownloadReport",
      "getLaborUnionSocietyConventionalPeriod",
    ]),
  },
  methods: {
    ...mapActions("modRequest", [
      "actGetDashboard",
      "actGetLaborUnions",
      "actGetSites",
      "actGetSocieties",
      "actGetDashboardBar",
    ]),
    ...mapActions("permisosSindicalesStatisticsLaborsUnions", [
      "getLaborGraphicData",
      "getWorkerInformation",
      "getDownloadReport",
      "getLaborUnionsSocietyConventionalPeriod",
      "clearGraphicData",
    ]),
    clearFilter() {
      this.userSelected.is_show = false;
      this.dateRanges.is_show = false;
      this.errorOfFilters.show = false;
      this.errorOfFilters.data = [];
    },
    async downloadReportOfLaborUnion() {
      const me = this;
      me.isProcessingDownloadlaborunion = true;

      const parameters = {
        labor_union: me.syndicateId,
        start_period: me.dateRanges.dateInit,
        end_period: me.dateRanges.dateEnd,
      };

      if (me.idOfSelectedSociety) {
        parameters.society = me.idOfSelectedSociety;
      }

      me.generarReport(parameters);
    },
    async downloadReportOfEmployee() {
      const me = this;
      const parameters = {
        labor_union: this.syndicateId,
        start_period: this.dateRanges.dateInit,
        end_period: this.dateRanges.dateEnd,
        employee: this.userSelected.sharp_id,
      };

      me.generarReport(parameters);
    },
    generarReport(parameters) {
      let link = `${process.env.VUE_APP_URL_API}/v2/permisos-sindicales/statistics/download-report?labor_union=${parameters?.labor_union}&start_period=${parameters?.start_period}&end_period=${parameters?.end_period}`;

      if (parameters.society) {
        link += `&society=${parameters?.society}`;
      }

      if (parameters.employee) {
        link += `&employee=${parameters?.employee}`;
      }

      const a = document.createElement("a");
      a.href = link;
      a.target = "_blank";
      a.click();
    },
    changeSyndicate({ id }) {
      this.syndicateId = id;
      // this.onTabChanged(id)
    },
    changeSelectUser({
      sharp_id,
      name,
      list_of_unions,
      identification_number,
      count_of_unions,
    }) {
      this.userSelected.is_show = true;
      this.userSelected.sharp_id = sharp_id;
      this.userSelected.name = name;
      this.userSelected.list_of_unions = list_of_unions;
      this.userSelected.identification_number = identification_number;
      this.userSelected.count_of_unions = count_of_unions;
      this.getWorkerInformation({
        labor_union: this.syndicateId,
        start_period: this.dateRanges.dateInit,
        end_period: this.dateRanges.dateEnd,
        employee: sharp_id,
      }).then(() => {
        this.workInformation.approved_with_tickets =
          this.getLaborWorkerInformation.approved_with_tickets;
        this.workInformation.approved_without_tickets =
          this.getLaborWorkerInformation.approved_without_tickets;
        this.workInformation.not_approved =
          this.getLaborWorkerInformation.not_approved;
      });
      this.onTabChanged(this.syndicateId, sharp_id);
    },
    changeRangeDates({
      dateInit,
      dateEnd,
      society,
      laborUnion,
      conventionalAgreement,
    }) {
      this.dateRanges.is_show = true;
      this.dateRanges.dateInit = dateInit;
      this.dateRanges.dateEnd = dateEnd;
      this.idOfSelectedSociety = society;
      this.conventionalAgreement = conventionalAgreement;
      this.onTabChanged(this.syndicateId, this.userSelected.sharp_id);

      this.getUnionsInformation({
        union: laborUnion,
        start_period: dateInit,
        end_period: dateEnd,
        conventionalAgreement,
        society,
      });

      this.loadStatisticsPayment({
        society,
        start_date: dateInit,
        end_date: dateEnd,
        labor_union: laborUnion,
      });
    },

    async getUnionsInformation({
      union = 0,
      start_period = "",
      end_period = "",
      conventionalAgreement = false,
      society = 0,
    }) {
      await this.getLaborUnionsSocietyConventionalPeriod({
        unionId: union,
        society: society,
        conventionalAgreement,
        data: {
          start_period,
          end_period,
        },
      })
        .then(() => {
          this.fillAvailabilityPermisionsChart();
          this.fillAvailabilityTicketsChart();
          this.fillAvailabilityTicketsInterChart();
          this.errorOfFilters.show = false;
          this.errorOfFilters.data = [];
        })
        .catch(
          ({
            response: {
              data: { message },
            },
          }) => {
            console.clear();
            this.errorOfFilters.show = true;
            this.errorOfFilters.data = message;
          }
        );
    },
    findDashboard() {
      let data = [];
      data[0] = this.yearSel;
      data[1] = this.laborUnion ? this.laborUnion : 1; // Sindicado por defecto
      //alert(JSON.stringify(data));

      this.actGetDashboard(data)
        .then(() => {
          this.fillTicketsLineChartData(this.yearSel);
          //this.fillAvailabilityPermisionsChart(this.yearSel);
          //  this.fillAvailabilityTicketsChart(this.yearSel);
          this.halfLicenses =
            this.dashboard.data[this.yearSel].half_day_licenses;
          //this.fillAvailabilityViaticsChart(this.year);
        })
        .catch((response) => {
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message = "No se pudo conectar al servicio: " + response;
        });
    },

    fillTicketsLineChartData(year) {
      this.available_licenses = this.dashboard.data[year].available_licenses;
      this.available_tickets = this.dashboard.data[year].available_tickets;
      this.available_viatics = this.dashboard.data[year].available_viatics;
    },
    fillAvailabilityPermisionsChart() {
      // console.log("entradno al dato")
      this.availabilityPermisionsChartdatacollection = {
        datasets: [
          {
            backgroundColor: ["#459BFF", "#1719DA", "#C33517", "#7E7E7E"],
            data: [
              this.getLaborUnionSocietyConventionalPeriod.days.used,
              this.getLaborUnionSocietyConventionalPeriod.days.available,
              this.getLaborUnionSocietyConventionalPeriod.days.pending,
              this.getLaborUnionSocietyConventionalPeriod.days.additional,
            ],
          },
        ],

        labels: [
          "Días utilizados",
          "Días disponibles",
          "Días pendientes",
          "Días adicionales utilizados",
        ],
      };
    },
    fillAvailabilityTicketsChart() {
      this.availabilityTicketsChartdatacollection = {
        datasets: [
          {
            backgroundColor: ["#459BFF", "#1719DA", "#C33517", "#7E7E7E"],
            data: [
              this.getLaborUnionSocietyConventionalPeriod.ticket_nationals.used,
              this.getLaborUnionSocietyConventionalPeriod.ticket_nationals
                .available,
              this.getLaborUnionSocietyConventionalPeriod.ticket_nationals
                .pending,
              this.getLaborUnionSocietyConventionalPeriod.ticket_nationals
                .additional,
            ],
          },
        ],

        labels: [
          "Tiquetes utilizados",
          "Tiquetes disponibles",
          "Tiquetes pendientes",
          "Tiquetes adicionales",
        ],
      };
    },
    fillAvailabilityTicketsInterChart() {
      this.availabilityTicketsInterChartdatacollection = {
        datasets: [
          {
            backgroundColor: ["#459BFF", "#1719DA", "#C33517", "#7E7E7E"],
            data: [
              this.getLaborUnionSocietyConventionalPeriod.ticket_internationals
                .used,
              this.getLaborUnionSocietyConventionalPeriod.ticket_internationals
                .available,
              this.getLaborUnionSocietyConventionalPeriod.ticket_internationals
                .pending,
              this.getLaborUnionSocietyConventionalPeriod.ticket_internationals
                .additional,
            ],
          },
        ],

        labels: [
          "Tiquetes utilizados",
          "Tiquetes disponibles",
          "Tiquetes pendientes",
          "Tiquetes adicionales",
        ],
      };
    },
    fillAvailabilityViaticsChart(year) {
      let numTickets =
        this.dashboard.data[year].monthly_report[0].January.Tickets +
        this.dashboard.data[year].monthly_report[1].February.Tickets +
        this.dashboard.data[year].monthly_report[2].March.Tickets +
        this.dashboard.data[year].monthly_report[3].April.Tickets +
        this.dashboard.data[year].monthly_report[4].May.Tickets +
        this.dashboard.data[year].monthly_report[5].June.Tickets +
        this.dashboard.data[year].monthly_report[6].July.Tickets +
        this.dashboard.data[year].monthly_report[7].August.Tickets +
        this.dashboard.data[year].monthly_report[8].September.Tickets +
        this.dashboard.data[year].monthly_report[9].October.Tickets +
        this.dashboard.data[year].monthly_report[10].November.Tickets +
        this.dashboard.data[year].monthly_report[11].December.Tickets;

      this.availabilityViaticsChartdatacollection = {
        datasets: [
          {
            backgroundColor: ["#4F656E", "#8196AA"],
            data: [
              numTickets,
              this.dashboard.data[year].available_tickets - numTickets,
            ],
          },
        ],

        labels: ["Utilizados", "Disponibles"],
      };
    },

    findFilterBar() {
      let data = [];
      data[0] = this.yearSel2;
      data[1] = this.societySelect;
      data[2] = this.sitesSelect;
      this.actGetDashboardBar(data).then(() => {
        this.findItemBar(this.item);
      });
    },

    findItemBar(e) {
      let labels = [];
      let data = [];

      // for(let anno in this.dashboardBar.data){
      //   for(let i=0; i<this.dashboardBar.data[anno].length; i++){
      //     let nameTmp = this.dashboardBar.data[anno][i].name.replace('SINDICALIZADOS','');
      //     let name = nameTmp.replace('Sindicato','');
      //     labels.push(this.stringConvert(name));
      //     if(e == 'Permisos'){
      //       data.push(this.dashboardBar.data[anno][i].licenses_days);
      //     }
      //     if(e == 'TiquetesNacionales'){
      //       data.push(this.dashboardBar.data[anno][i].national_tickets);
      //     }
      //     if(e == 'TiquetesInternacionales'){
      //       data.push(this.dashboardBar.data[anno][i].international_tickets);
      //     }
      //     if(e == 'Viaticos'){
      //       data.push(this.dashboardBar.data[anno][i].viatics);
      //     }
      //   }
      // }

      this.chartData = {
        labels: labels,
        datasets: [
          {
            label: e,
            borderWidth: 1,
            backgroundColor: [
              "rgba(255, 99, 132, 0.2)",
              "rgba(54, 162, 235, 0.2)",
              "rgba(255, 206, 86, 0.2)",
              "rgba(75, 192, 192, 0.2)",
              "rgba(153, 102, 255, 0.2)",
              "rgba(255, 159, 64, 0.2)",
              "rgba(255, 99, 132, 0.2)",
              "rgba(54, 162, 235, 0.2)",
              "rgba(255, 206, 86, 0.2)",
            ],
            borderColor: [
              "rgba(255,99,132,1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
              "rgba(75, 192, 192, 1)",
              "rgba(153, 102, 255, 1)",
              "rgba(255, 159, 64, 1)",
              "rgba(255,99,132,1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
            ],
            pointBorderColor: "#2554FF",
            data: data,
          },
        ],
      };
    },

    stringConvert(str) {
      return str
        .toLowerCase()
        .trim()
        .split(" ")
        .map((v) => v[0].toUpperCase() + v.substr(1))
        .join(" ");
    },

    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
    async onTabChanged(key, sharp_id) {
      // this.isProcessingDownload = true
      let query =
        sharp_id == null
          ? {
              labor_union: key,
              start_period: this.dateRanges.dateInit,
              end_period: this.dateRanges.dateEnd,
            }
          : {
              labor_union: key,
              start_period: this.dateRanges.dateInit,
              end_period: this.dateRanges.dateEnd,
              employee: sharp_id,
            };
      if (this.idOfSelectedSociety) {
        query.society = this.idOfSelectedSociety;
      }

      this.processingGraphic = true;
      await this.getLaborGraphicData(query)
        .then(() => {
          this.errorOfFilters.show = false;
          this.errorOfFilters.data = [];
        })
        .catch(
          ({
            response: {
              data: { message },
            },
          }) => {
            this.errorOfFilters.show = true;
            this.errorOfFilters.data = message;
            this.clearGraphicData();
            console.clear();
          }
        )
        .finally(() => {
          const labelsMonthsApproved = makeLabel(
            this.getGraphicDataUnion.approved
          );
          const uniqueApproved = labelsMonthsApproved.filter(onlyUnique);
          const labelsMonthsTickets = makeLabel(
            this.getGraphicDataUnion.tickets
          );
          const uniqueTickets = labelsMonthsTickets.filter(onlyUnique);
          /*
        end
        */
          /*
        approbers
        */
          const automatics = getResultApproved(
            uniqueApproved,
            this.getGraphicDataUnion.approved,
            true
          );
          const aprobbers = getResultApproved(
            uniqueApproved,
            this.getGraphicDataUnion.approved,
            false
          );
          const aprobberValues = getValues(aprobbers);
          const automaticsValues = getValues(automatics);
          /*
        end
        */
          /*
        tickets
        */
          const tickerIsNotRequiredTypeNull = getResultTickets(
            uniqueTickets,
            this.getGraphicDataUnion.tickets,
            false,
            null
          );
          const tickerIsNotRequiredTypeNullValues = getValues(
            tickerIsNotRequiredTypeNull
          );
          const tickerIsRequiredTypeNational = getResultTickets(
            uniqueTickets,
            this.getGraphicDataUnion.tickets,
            true,
            "Nacional"
          );
          const tickerIsRequiredTypeNationalValues = getValues(
            tickerIsRequiredTypeNational
          );
          const tickerIsRequiredTypeInternacional = getResultTickets(
            uniqueTickets,
            this.getGraphicDataUnion.tickets,
            true,
            "Internacional"
          );
          const tickerIsRequiredTypeInternacionalValues = getValues(
            tickerIsRequiredTypeInternacional
          );
          /*
        end
        */
          function getResultTickets(
            months = [],
            array = [],
            conditionTicketRequested = true,
            conditionType = null
          ) {
            return months.map((value) => {
              return array.find(
                ({ month, year, ticket_requested, type }) =>
                  month.concat(` ${year}`) == value &&
                  ticket_requested == conditionTicketRequested &&
                  type == conditionType
              );
            });
          }
          function getResultApproved(
            months = [],
            array = [],
            condition = false
          ) {
            return months.map((value) => {
              return array.find(
                ({ month, year, is_automatic_approval }) =>
                  month.concat(` ${year}`) == value &&
                  is_automatic_approval == condition
              );
            });
          }
          function getValues(array = []) {
            return array.map((value) => (value ? value.count : 0));
          }
          function makeLabel(array = []) {
            return array.map((item) => {
              return item.month.concat(` ${item.year}`);
            });
          }
          function onlyUnique(value, index, array) {
            return array.indexOf(value) === index;
          }

          this.permissionsDataCollection = {
            labels: uniqueApproved,
            datasets: [
              {
                label: "Automáticos",
                backgroundColor: "#459BFF",
                data: automaticsValues,
                barPercentage: 0.5,
                categoryPercentage: 1,
                maxBarThickness: 100,
              },
              {
                label: "Por aprobador",
                backgroundColor: "#1719DA",
                data: aprobberValues,
                barPercentage: 0.5,
                categoryPercentage: 1,
                maxBarThickness: 100,
              },
            ],
          };

          this.ticketsLineChartdatacollection = {
            labels: uniqueTickets,
            datasets: [
              {
                label: "Nacionales",
                backgroundColor: "#B039CE",
                data: tickerIsRequiredTypeNationalValues,
                barPercentage: 0.5,
                categoryPercentage: 1,
                maxBarThickness: 100,
              },
              {
                label: "Internacionales",
                backgroundColor: "#29B0A0",
                data: tickerIsRequiredTypeInternacionalValues,
                barPercentage: 0.5,
                categoryPercentage: 1,
                maxBarThickness: 100,
              },
              {
                label: "Sin tiquetes",
                backgroundColor: "#382983",
                data: tickerIsNotRequiredTypeNullValues,
                barPercentage: 0.5,
                categoryPercentage: 1,
                maxBarThickness: 100,
              },
            ],
          };

          this.processingGraphic = false;
        });

      //End Get data Labor Graphic
    },
    async loadStatisticsPayment(params) {
      const me = this;
      const seriesTotals = [];
      const categories = [];
      const series = [
        {
          name: "Nacional",
          data: [],
        },
        {
          name: "Internacional",
          data: [],
        },
      ];
      try {
        const { data } = await getStatisticsPayments(params);
        const records = Object.values(data).flat();
        records.forEach((item) => {
          const record = seriesTotals.find((y) => y.month === item.month);
          if (record) {
            record.data.push(item);
          } else {
            seriesTotals.push({
              month: item.month,
              data: [item],
            });
          }
        });
        seriesTotals.forEach((item) => {
          categories.push(item.month);
          item.data.forEach((y) => {
            if (y?.type === "Nacional") {
              series[0].data.push(y.total_amount);
            } else {
              series[1].data.push(y.total_amount);
            }
          });
        });
        me.updateChart(series, categories);
      } catch (error) {
        console.log(error);
      }
    },
    updateChart(series, categories) {
      const me = this;
      const chart = me.$refs[me.refChart];
      chart.updateOptions({
        xaxis: {
          categories,
        },
      });
      chart.updateSeries(series);
    },
  },
};
</script>
<style lang="scss">
#page-dashboard {
  .break-padding {
    padding: 0;
  }

  .box-medium {
    gap: 20px;
    flex-wrap: wrap;
    padding: 0;
  }
  .cont-title {
    margin-top: 5px;
    h3 {
      color: #1c3a4e;
      font-size: 12px;
      line-height: 18px;

      @media (min-width: 768px) {
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
      }
    }

    .icon {
      color: #1c3a4e;
      font-size: 18px;

      @media (min-width: 768px) {
        font-size: 22px;
      }
    }
  }
  .box-info-sindicato {
    gap: 13px;
    align-items: center;
    flex-wrap: wrap;
  }
  .box-info-sindicato strong {
    font-weight: bold;
    font-size: 20px;
  }
  .box-info-sindicato p {
    margin: 0;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  // .box-content-main-graph {
  //   display: flex;
  //   gap: 30px;
  // }
  .item-graph {
    &_one,
    &_two {
      flex: 0 0 100%;
      max-width: 100%;
    }
    &_one {
      @media (min-width: 768px) {
        flex: 0 0 35%;
        max-width: 35%;
      }
    }
    &_two {
      @media (min-width: 768px) {
        flex: 0 0 64%;
        max-width: 64%;
      }
    }
  }
  .dashboard-permissions {
    max-width: 300px;
    width: 100%;
    margin: 0 auto;
    position: relative;
    z-index: 9;
  }
  .title-chart-multi {
    font-size: 19px;
    font-weight: 600;
  }
  .border-column {
    border-bottom: 1px solid #e9e9e9;
    @media (min-width: 768px) {
      border-right: 1px solid #e9e9e9;
    }
  }
  .cont-chart {
    padding: 20px 20px 30px 20px;
    .chart-select {
      border: 0 none;
      color: #303030;
      font-weight: 500;
      outline: none;

      &:focus {
        outline: none;
      }
    }
  }
  .conten-grafic-ticket {
    display: flex;
    flex-wrap: wrap;
  }
  .box-info-total {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .box-content-ticket {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding: 0;
    @media (min-width: 768px) {
      flex-direction: row;
    }
  }
  .text-card-grafic {
    font: normal normal 700 14px/1 "Ubuntu";
    color: #000000;
  }
  .text-card-grafic-number {
    font: normal normal 700 40px/1 "Ubuntu";
    color: #000000;
  }

  .cont-doughnut-chart {
    .title-top {
      margin: 0 auto 1.5rem !important;
      max-width: 190px;
    }
    .cont-txt {
      color: #303030;
      width: 100% !important;
      height: 120px !important;
      top: calc(50%) !important;
      left: calc(50%) !important;
      transform: translate(-50%, -50%) !important;
      max-width: 180px;
      .title {
        margin-bottom: 0;
        font: normal normal 300 14px/1 "Ubuntu";
        color: #303030;
      }
      .number {
        margin-bottom: 0;
        padding: 10px 0;
        color: #303030;
        font: normal normal bold 20px/1 "Ubuntu" !important;
      }
      .cont-desc {
        font-size: 12px;
        p {
          margin-bottom: 0;
        }
      }
    }
    .cont-botton {
      color: #303030;
      width: 100% !important;
      height: 120px !important;
      bottom: 0 !important;
      flex-direction: column;
      .title {
        margin-bottom: 0;
        font: normal normal 300 16px/1 "Ubuntu";
        color: #303030;
      }
      .number {
        margin-bottom: 0;
        padding: 10px 0;
        color: #303030;
        font: normal normal bold 20px/1 "Ubuntu" !important;
      }
    }
  }

  .cont-permisions {
    color: #303030;
    .number {
      font-size: 28px;
      font-weight: bold;

      @media (min-width: 768px) {
        font-size: 48px;
      }
    }
    .txt {
      font-size: 14px;
      line-height: 16px;

      @media (min-width: 768px) {
        font-size: 16px;
        line-height: 18px;
      }
    }
  }
  .baseline_box label {
    color: #78909c;
  }
  .b-form-datepicker {
    background: #ffffff;
    border: 1px solid transparent;
    border-radius: 8px;
    height: 40px !important;
    align-items: center;
  }

  .b-form-datepicker label {
    position: relative;
    left: initial;
    top: 0;
    padding: 0;
    text-align: left;
    line-height: 1;
    min-height: auto;
  }
  .custom-select {
    background: url("../../assets/images/icons/arrow-select.svg") center
      right/22px no-repeat;
  }
  .name-union {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    font-family: Ubuntu;
    line-height: 22px;
    margin-bottom: 6px;
  }
  .box-tabs,
  .tabs-labor-union .card-body {
    display: flex;
    flex-direction: row;
    gap: 4px;
    padding: 8px;
    border-radius: 50px;
    border: 1px solid #c9caff;
    width: max-content;
  }
  .nav-item.active a {
    color: #ffffff !important;
    background: #5d5fef !important;
  }
  .nav-item a,
  .tabs-labor-union a,
  .tabs-labor-union-item {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    font-family: Ubuntu;
    line-height: 1;
    color: #5d5fef;
    background: #ffffff;
    transition: all 0.3s ease;
    border-radius: 50px;
    display: block;
    padding: 8px 16px;
    width: max-content;
    cursor: pointer;
    border: none !important;
    margin: 2px 0px;
    &:hover,
    &.active {
      color: #ffffff !important;
      background: #5d5fef !important;
    }
    /* &.active {
        pointer-events: none;
      } */
  }
  .tabs-labor-union .tab-content {
    display: none;
  }
  .box-general {
    display: flex;
    flex-direction: row;
    gap: 20px;
  }
  .button-descargar {
    position: relative;
    z-index: 9;
    background: white;
    border: none;
    color: #5d5fef;
    font-family: Ubuntu;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    border: 1px solid #5d5fef;
    border-radius: 5px;
    margin: 15px 15px 15px auto;
    @media (min-width: 576px) {
      position: absolute;
      top: 15px;
      right: 15px;
      margin: 0;
    }
  }
  .info-user {
    display: flex;
    flex-direction: row;
    gap: 20px;
    p {
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
      font-family: Ubuntu;
      line-height: 22px;
      margin-bottom: 6px;
    }
  }
  .vmp-input-append {
    display: none;
  }
  .no-padding {
    margin: 0 !important;
  }
}
</style>
